import { createElementBlock as o, openBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function l(s, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M10.5 1.8a8.7 8.7 0 1 0 5.1 1.65"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
